import axios from "axios"
import { ClientsAddressesDataUpdate, ClientsTypeDataCreate } from "./address.type.service"

// Add new client address
async function postCientAddressApi (uuid: string, clientUuid: string, data: ClientsTypeDataCreate) {
    return axios({
        method: 'POST',
        url: `/api/v1/workspaces/${uuid}/clients/${clientUuid}/addresses`,
        data: data
    });
}

// Get addresses details of the user
async function getClientAddressesApi(uuid: string, clientUuid: string) {
    if (uuid !== undefined && clientUuid !== undefined){
        return axios({
            method: 'GET',
            url: `/api/v1/workspaces/${uuid}/clients/${clientUuid}/addresses`
        });}
}

// Patch client addresses
async function PatchClientAddressesApi(uuid: string, clientUuid: string, addressUuid: string, data: ClientsAddressesDataUpdate) {
    return axios({
        method: 'PATCH',
        url: `/api/v1/workspaces/${uuid}/clients/${clientUuid}/addresses/${addressUuid}`,
        data: data
    });
}

// Delete chosen client address
async function deleteCustomerAddressApi(uuid: string, clientUuid: string, addressUuid: string) {
    return axios({
        method: 'DELETE',
        url: `/api/v1/workspaces/${uuid}/clients/${clientUuid}/addresses/${addressUuid}`
    });
}

export {
    deleteCustomerAddressApi,
    getClientAddressesApi,
    PatchClientAddressesApi,
    postCientAddressApi
}
